import { render } from "./ordemServicoPopUp.vue?vue&type=template&id=5a4da002"
import script from "./ordemServicoPopUp.vue?vue&type=script&lang=js"
export * from "./ordemServicoPopUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__